import {
  AUTH_TOKEN,
  AUTH_USER_PROFILE,
  SYSTEM_SETTING,
} from "./../common/StorageKeys";
import { get, post } from "@/utils/Request";
import JsonStorage from "@rpdg/revue-utils/JsonStorage";

export interface ISystemSetting {
  banners?: Banner[];
  priceInfo?: Price;
  kefuInfo?: {
    weixin: string;
    weixinQrCode: string;
  };
  orderCount: number;
}

export interface Banner {
  name?: string;
  imgSrc?: string;
  orderIndex?: number;
  enabled?: boolean;
  description?: string;
  id?: number;
  linkUrl?: string;
}

export interface Price {
  questionPrice?: number;
  questionOldPrice?: number;
  fastQuestionPrice?: number;
  fastQuestionOldPrice?: number;
}

class AuthStore {
  token: string = "";

  constructor() {
    this.token = this.getToken();
  }

  async getAuthCode() {
    return await get<{ url: string }>("/h5/auth/getcode");
  }

  async signin(code: string) {
    return await post<{ openid: string; access_token: string }>(
      `/h5/auth/signin/${code}`
    );
  }

  async getUserProfile() {
    const res = await get<{ headimgurl: string; nickname: string }>(
      "h5/user/profile"
    );
    JsonStorage.set(AUTH_USER_PROFILE, res);
    await this.getSystemSettings();
  }

  async getSystemSettings() {
    const res = await get<ISystemSetting>("h5/systemsettings/");
    JsonStorage.set(SYSTEM_SETTING, res);
    return res;
  }

  getToken() {
    return JsonStorage.get<string>(AUTH_TOKEN, "");
  }

  setToken(token: string) {
    this.token = token;
    JsonStorage.set(AUTH_TOKEN, token);
  }

  removeToken() {
    JsonStorage.remove(AUTH_TOKEN);
    JsonStorage.remove(AUTH_USER_PROFILE);
  }

  async getUserProfileFromStorage() {
    await this.getUserProfile();
    return JsonStorage.get<{
      headimgurl: string;
      nickname: string;
      sex: number | string;
      country: string;
      city: string;
      divinatoryCount: number;
      isAgreementAccepted: boolean;
    }>(AUTH_USER_PROFILE, {
      headimgurl: "",
      nickname: "",
      sex: "",
      country: "",
      city: "",
      divinatoryCount: 0,
      isAgreementAccepted: false,
    });
  }

  async getSystemSettingFromStorage() {
    let systemSetting = JsonStorage.get<ISystemSetting | null>(
      SYSTEM_SETTING,
      null
    );
    if (!systemSetting) {
      await this.getSystemSettings();
      systemSetting = JsonStorage.get<ISystemSetting | null>(SYSTEM_SETTING, {
        banners: [],
        price: {
          questionPrice: 0,
          questionOldPrice: 0,
          fastQuestionPrice: 0,
          fastQuestionOldPrice: 0,
        },
        kefuWeixin: {
          weixin: "",
          weixinQrCode: "",
        },
        orderCount: 0,
      } as ISystemSetting);
    }
    return systemSetting;
  }
}

export default new AuthStore();
